module.exports = __webpack_public_path__ + "static/img/Front Eureka_5.107776d2.png";